module.exports = __webpack_public_path__ + "media/images/home/bg-3-83616b88aebb4a7ec0ec5402c2986451.png";